/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcuser.vcuser')
    .component('userform', {
      restrict: 'E',
      bindings: {
        user: '<',
        parentsave: '&',
        oncancel: '&',
        roles: '<?'
      },
      templateUrl: 'vcuser/vcuser/userform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          // vm.zipsave = zipsave;

          vm.$onInit = function () {
            vm.lastuser = angular.copy(vm.user);
            if (angular.isUndefined(vm.roles) || !angular.isArray(vm.roles) || vm.roles.length === 0) {
              vm.roles = [{role: 'admin', label: 'Administrator'},{role: 'user', label: 'Anwender'}];
            }
          };

          function save() {
            $log.debug('user role: ', vm.user.role);
            if (angular.isDefined(vm.user.role) && angular.isString(vm.user.role) && vm.user.role.length > 0) {
              vm.user.roles = [vm.user.role];
            }
            if (!angular.equals(vm.user, vm.lastuser)) {
              vm.lastuser = angular.copy(vm.user);
              vm.parentsave({user: vm.user});
            }
          }

          function cancel() {
            vm.user = angular.copy(vm.lastuser);
            vm.oncancel();
          }


          /*          function zipsave (zip, city) {
           $log.debug('debug: userform zipsave called: ', zip, city);
           // vm.user.postcode = zip;
           // vm.user.city = city;
           }*/


        }] // controller
    }); // component

// klammerfriedhof
}());